/**
 * Maps GET /property/getBookingSettingsByPropertyId `result` into Redux `bookingSettings` shape.
 * Cancellation policy is a single catalog code (string | null). Pre-migration /
 * partner-mapped properties may return null, which the settings picker renders unselected.
 */
export function transformBookingSettingsFromApi(data: any): Record<string, any> | null {
  if (!data) return null;

  let propertyPolicy: any[] = [];
  try {
    const pp = data.propertyPolicy;
    if (pp != null) {
      const parsed = typeof pp === 'string' ? JSON.parse(pp) : pp;
      propertyPolicy = Array.isArray(parsed) ? parsed : [];
    }
  } catch {
    propertyPolicy = [];
  }

  return {
    checkInTime: data.checkInTime ?? '',
    checkOutTime: data.checkOutTime ?? '',
    bookingApproval: data.approvalRequiredForBooking ? 'requestToBook' : 'instantBooking',
    minDayBooking: data.minDayBooking ?? data.minNights ?? '',
    maxDayBooking: data.maxDayBooking ?? data.maxNights ?? '',
    cancellationPolicyCode:
      typeof data.cancellationPolicyCode === 'string' ? data.cancellationPolicyCode : null,
    customCancellationPolicy:
      data.customCancellationPolicy && typeof data.customCancellationPolicy === 'object'
        ? data.customCancellationPolicy
        : null,
    restrictions: propertyPolicy,
    partialPaymentAllowed:
      typeof data.partialPaymentAllowed === 'boolean' ? data.partialPaymentAllowed : true,
    partialPaymentPercentage: (() => {
      const n = Number(data.partialPaymentPercentage);
      // Only fill a missing value: an advance saved below the current 50% minimum is kept as stored.
      // The minimum is enforced when the host changes the value, not when an old listing loads.
      if (!Number.isFinite(n) || n < 1) return 50;
      return Math.min(100, Math.round(n));
    })(),
  };
}
